// src/config/supabase.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://rotohdtbuqpeymjaiybu.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJvdG9oZHRidXFwZXltamFpeWJ1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU0NzM4MjUsImV4cCI6MjA4MTA0OTgyNX0.snkJfxn3xSwVElKhgKM83a4SHQU8TXSmjJyY7TKren8';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase;
